import PaginationLabelComponent from '../PaginationLabelComponent';

const PaginationLabelResolver =
  (isPlanList: boolean) => (reviewCount: string, totalCount: number) => (
    <PaginationLabelComponent
      reviewCount={reviewCount}
      totalCount={totalCount}
      isPlanList={isPlanList}
    />
  );

export default PaginationLabelResolver;
